<template>
    <button :type="type" :class="{ 'opacity-25': form.processing }" :disabled="form.processing || disabled" class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-purple-800 disabled:bg-purple-300 disabled:cursor-not-allowed hover:bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500">
        <div v-if="form.processing" class="mr-1"><font-awesome-icon :icon="faCircleNotch" spin /></div>
        <slot></slot>
    </button>
</template>

<script>
    import { faCircleNotch } from '@fortawesome/pro-solid-svg-icons'

    export default {
        props: {
            form: Object,
            type: {
                type: String,
                default: 'submit',
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                faCircleNotch
            }
        }
    }
</script>
